import React, { createContext, ReactNode, useContext, useMemo } from 'react';

import { ChatMeta } from '../V2/model/interfaces/ChatMeta';
import { useGetChatMeta } from '../V2/services/notifications/useGetChatMeta';

const defaultChatMeta: ChatMeta = {
  id: 0,
  username: '',
  credits: 0,
  unread_visitor_notifications: 0,
  unread_message_notifications: 0,
  unread_message_notifications_conversations: 0,
  voice_message_cost: 0
};

const ChatMetaContext = createContext<ChatMeta>(defaultChatMeta);

export const ChatMetaProvider = ({ children }: { children: ReactNode }) => {
  const { data } = useGetChatMeta();

  const value = useMemo(() => data?.data ?? defaultChatMeta, [data?.data]);

  return <ChatMetaContext.Provider value={value}>{children}</ChatMetaContext.Provider>;
};

export const useChatMeta = () => {
  const context = useContext(ChatMetaContext);
  if (!context) {
    throw new Error('useChatMeta must be used within a ChatMetaProvider');
  }
  return context;
};
